import EditIcon from '@material-ui/icons/Edit';
import React from 'react';
import {CloseButton, PORTAL_NAVY} from '../../../common';

type Props = {
    open: boolean;
    title: string;
    /**
     * The glyph before the title, passed with fontSize inherit so it sizes to the title. The pencil
     * unless the caller says otherwise, and nothing at all when the caller passes null.
     */
    icon?: React.ReactNode;
    onClose: () => void;
    children?: React.ReactNode;
};

/** The mockup's panel is about a fifth of a 1680px screen. */
export const DRAWER_WIDTH = 360;

/**
 * The Contact Management drawer (BHPNPP-3241): a column beside the page content, below the blue
 * header, that the layout renders through its sidePanel slot. It takes its own width and the page
 * content narrows to make room, so the contact table stays visible and clickable beside it. That is
 * the point of a drawer here rather than a centred dialog: a provider fixes one contact, clicks the
 * next row's pencil, and keeps going.
 *
 * <p>The column runs the full height of the main area and scrolls with the page, like the mockup.
 * The form is taller than most viewports, so pinning it would only hide its bottom.
 *
 * <p>The same column carries the Contact History panel (BHPNPP-3248), whose mockup heads the column
 * with the words alone. The title is what tells the two apart, so the glyph is the caller's choice.
 */
export const ContactDrawer = ({open, title, icon = <EditIcon fontSize="inherit"/>, onClose, children}: Props) => {
    if (!open) {
        return null;
    }

    return (
        <aside data-testid="contact-drawer"
               aria-label={title}
               className="flex-shrink-0 bg-white border-l border-gray-200"
               style={{width: DRAWER_WIDTH}}>
            <header className="flex items-center justify-between px-6 pt-6 pb-4">
                <h3 className="text-2xl font-bold flex items-center" style={{color: PORTAL_NAVY}}>
                    {icon && <span className="flex mr-2">{icon}</span>}
                    {title}
                </h3>
                <CloseButton onClick={onClose}/>
            </header>
            {children}
        </aside>
    );
};
